import styled from 'styled-components'
import { List } from 'antd'
import { blue } from '../../color'

export const ListWrapper = styled(List)`
  .ant-list {
    position: relative;
  }

  .ant-list-header {
    background-color: ${blue};
    color: #fff;
    padding: 16px 0;
  }

  .item-unread {
    //background-color: #ebf2ff;
    font-weight: bold;
  }

  .assign {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 160px;

    ul {
      justify-content: flex-start;
    }
  }
`
export const ListItem = styled(List.Item)``

export const UploadFileListWrapper = styled.ul`
  margin: 10px 0 15px;
  padding-left: 0 !important;
`

export const MessageListWrapper = styled.div`
  max-height: 85vh;
  overflow-y: scroll;
  margin: -1rem;

  .center-spin {
    padding-top: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .ant-list-item {
    cursor: pointer;

    &:hover {
      background-color: #fafafa;
    }
`